<template>
    <div class="recommended_articles column-direction">
        <div class="part_title second_font text_center">
            כתבות מומלצות
        </div>
        <div class="articles_list flex">
            <single-recommended
                v-for="article in articles"
                :key="article.id"
                :article="article"
            />
        </div>

        <div v-if="showMore" class="btn_wrapper text_center">
            <button
                class="btn btn_green_empty"
                type="button"
                @click="fetchArticles"
            >
                כתבות נוספות
            </button>
        </div>
    </div>
</template>

<script>
import Recommended from './Recommended';

export default {
    extends: Recommended
};
</script>
